import { SET_RESETPASSWORD_LOADING } from '../actions/signUpActions'

const initialState = false

const passwordreset = (state = initialState, action) => {
    switch (action.type) {
        case SET_RESETPASSWORD_LOADING:
            return action.bool

        default:
            return state
    }
}

export default passwordreset